<app-special-investment-table
  [currentTabname]="tabName"
  [prevDocumentType]="prevDocumentType"
  [isRFPAwardLetter]="true"></app-special-investment-table>
